import instance from './';
import config from '../../config';

const { skewedAnalyticsUploadedReportsUrl } = config;

export class SkewedAnalyticsService {
    /**
     * Upload a report file for a specific network (Admin only)
     * @param {number} networkId - Network ID
     * @param {FormData} formData - Form data containing the file
     * @returns {Promise<Object>} Upload response with reportId and expiresAt
     */
    static async uploadReport(networkId, formData) {
        const res = await instance.post(`${skewedAnalyticsUploadedReportsUrl}/${networkId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res.data;
    }

    /**
     * List all uploaded reports for a specific network (Admin only)
     * @param {number} networkId - Network ID
     * @returns {Promise<Object>} Response object with reports array
     */
    static async listReports(networkId) {
        const res = await instance.get(`${skewedAnalyticsUploadedReportsUrl}/${networkId}`);
        return res.data;
    }

    /**
     * Delete a report (Admin - hard delete from S3 + DB)
     * @param {number} networkId - Network ID
     * @param {string} reportId - Report ID
     * @returns {Promise<Object>} Delete response
     */
    static async deleteReport(networkId, reportId) {
        const res = await instance.delete(`${skewedAnalyticsUploadedReportsUrl}/${networkId}/${reportId}`);
        return res.data;
    }

    /**
     * Get a signed download URL for a report
     * @param {number} networkId - Network ID
     * @param {string} reportId - Report ID
     * @returns {Promise<Object>} Response with signedUrl
     */
    static async getDownloadUrl(networkId, reportId) {
        const res = await instance.get(`${skewedAnalyticsUploadedReportsUrl}/${networkId}/${reportId}/download-url`);
        return res.data;
    }

    /**
     * Revert a soft-deleted report (Admin only)
     * @param {number} networkId - Network ID
     * @param {string} reportId - Report ID
     * @returns {Promise<Object>} Revert response
     */
    static async revertReportDeletion(networkId, reportId) {
        const res = await instance.patch(`${skewedAnalyticsUploadedReportsUrl}/${networkId}/${reportId}/revert`);
        return res.data;
    }
}
